import React from 'react';
import { default as Features } from '../../components/feature/Feature';
import './whatgpt3.css';

const WhatGPT3 = () => {
    return (
        <div className="gpt3__whatgpt3 section__margin" id="wgpt3">
            <div className="gpt3__whatgpt3-feature">
                <Features title='What is GPT-3' text='Lorem, ipsum dolor sit amet consectetur adipisicing elit. Cumque velit maiores aut delectus nam ab obcaecati magnam qui assumenda ea autem, tenetur nulla vel ratione molestias sit saepe sapiente quis?'/>
            </div>
            <div className="gpt3__whatgpt3-heading">
                <h1 className="gradient__text">
                    The possibilities are beyond your imagination
                </h1>
                <p>Explore The Library</p>
            </div>
            <div className="gpt3__whatgpt3-container">
                <Features title='Chatbots' text='Lorem, ipsum dolor sit amet consectetur adipisicing elit. Cumque velit maiores aut delectus nam ab obcaecati magnam qui assumenda ea autem' />
                <Features title='Knowledgebase' text='Lorem, ipsum dolor sit amet consectetur adipisicing elit. Cumque velit maiores aut delectus nam ab obcaecati magnam qui assumenda ea autem' />
                <Features title='Education' text='Lorem, ipsum dolor sit amet consectetur adipisicing elit. Cumque velit maiores aut delectus nam ab obcaecati magnam qui assumenda ea autem' />
            </div>
        </div>
    )
}

export default WhatGPT3
